import { useNavigate } from 'react-router-dom'

import Button from 'components/button'
import PopupWrapper from 'components/popup/wrapper/wrapper'
import FavoriteButton from 'components/workouts/favorite-button'
import { pathsObj } from 'lib/constants/paths'
import { useSetPopup } from 'store/config/selectors'
import { useWorkoutSession } from 'store/workout/selectors'
import SetupFreestyleIntensity from './setup-intensity'

const FavoriteFreestylePreview = () => {
  const navigate = useNavigate()
  const workoutSession = useWorkoutSession()
  const { closePopup } = useSetPopup()
  const firstRound = workoutSession.rounds[0]
  const rounds = workoutSession.rounds.length
  const seconds = firstRound?.exercises[0]?.seconds ?? 0
  const rest = firstRound?.breakSeconds ?? 0

  const startFreestyle = () => {
    closePopup()
    navigate(pathsObj.rounds.roundOverview)
  }

  return (
    <PopupWrapper>
      <SetupFreestyleIntensity />
      <div className="favoriteFreestylePreview__settings" aria-label="Saved Freestyle settings">
        <h4>{rounds} rounds</h4>
        <h4>{seconds} seconds work</h4>
        <h4>{rest} seconds rest</h4>
      </div>
      <div className="popupFreestyle__buttons">
        <div />
        <div />
        <div className="popupFreestyle__buttons--right popupFreestyle__actionGroup">
          <FavoriteButton />
          <Button fullColor customClickEvent={startFreestyle}>
            <h3>Start Freestyle</h3>
          </Button>
        </div>
      </div>
    </PopupWrapper>
  )
}

export default FavoriteFreestylePreview
